<template>
  <!-- TODO: static text in this components still needs to be translated -->
  <div class="order-sum summary-details">
    <div class="detail__list">
      <div class="detail__entry order-sum__entry">
        <div class="order-sum__label">{{$t("checkout.paymentDetails.totalPrice")}}</div>
        <div class="order-sum__value">
          <template v-if="discountApplied">
            <s class="is-5 has-text-danger is-size-6 is-block">
              {{ positionPrice.beforeDiscount.netPrice | toCents | currency }}
            </s>
          </template>
          <template>
            <h3 class="property__value is-5">
              <template v-if="cartSum">
                {{ cartSum.netPrice | toCents | currency }}
              </template>
              <template v-else>
                {{ positionPrice.netPrice | toCents | currency }}
              </template>
            </h3>
          </template>
        </div>
      </div>
      <div
        v-if="smallOrderSurcharge && smallOrderSurcharge.netPrice > 0"
        class="detail__entry order-sum__entry"
      >
        <div class="order-sum__label">{{$t("checkout.paymentDetails.minimumQuantitySurcharge")}}</div>
        <div class="order-sum__value">
          <h3 class="property__value is-5">
            {{ smallOrderSurcharge.netPrice | toCents | currency }}
          </h3>
        </div>
      </div>
      <div class="detail__entry order-sum__entry">
        <div class="order-sum__label">{{$t("checkout.paymentDetails.shippingCost")}}</div>
        <div class="order-sum__value">
          <template
            v-if="
              shippingMethod.shippingMethod === 'Standard-Versand' &&
                positionPrice.netPrice > 250
            "
          >
            {{ $t("discount.free") }}
          </template>
          <template v-else>
            {{ shippingMethod.pricing.netPrice | currency }}
          </template>
        </div>
      </div>
      <div class="detail__entry order-sum__entry">
        <div class="order-sum__label">{{$t("checkout.paymentDetails.subTotal")}}</div>
        <div class="order-sum__value">
           {{ orderSum.netPrice | toCents | currency }}
        </div>
      </div>
      <div
        v-if="(!isBusinessCustomer && taxRate > 0) || $route.params.orderId"
        class="detail__entry order-sum__entry"
      >
        <div class="cart-sum__label">
          <div>
            <span>{{
              $t("checkout.cart.singlePriceIncludingXPercentTaxes", { taxRate })
            }}</span>
          </div>
        </div>
        <div class="cart-sum__value" v-if="orderSum">
          {{ orderSum.tax || orderSum.calculatedTaxes.tax | toCents | currency }}
        </div>
      </div>
      <div
        class="
          detail__entry
          order-sum__entry--primary
          has-background-primary-dark has-text-light
          section
          mt-2
        "
      >
        <div class="order-sum__label">
          <span class="title is-4 has-text-white">{{$t("checkout.paymentDetails.totalPaymentAmount")}}</span>
          <span v-if="taxRate === 0">
            {{ $t("checkout.cart.noTaxIncluded") }}
          </span>
          <span v-else-if="isBusinessCustomer || $route.params.orderId">{{
            $t("checkout.cart.singlePriceIncludingXPercentTaxes", { taxRate }) }}
          </span>
        </div>
        <strong
          v-if="orderSum"
          class="order-sum__value title is-4 has-text-white"
        >
          <template v-if="discountApplied && orderSum.beforeDiscount">
            <s class="is-5 has-text-danger is-size-6 is-block mb-1 has-text-right">
              {{ orderSum.beforeDiscount.totalPrice | toCents | currency }}
            </s>
          </template>
          <template>
            <div class="order-sum__value is-5" v-if="orderSum">
              {{ orderSum.totalPrice | toCents | currency }}
            </div>
          </template>
        </strong>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { discountMixin } from "@/mixins/discountMixin";
import { calculateTaxes } from "../../../utilities/tax-calculations";

export default {
  name: "OrderSum",
  mixins: [discountMixin],
  data() {
    return {
      // TODO: This constant represents the converted value of 200 CHF in EUR
      // The conversion rate is by no means static, so minimumOrderValue needs to be calculated dynamically
      minimumOrderValue: 200, // this is in CHF!!
    };
  },
  mounted() {
    console.log('orderTrackingInfo:', this.orderTrackingInfo);
  },
  computed: {
    ...mapGetters([
      "positionPrice",
      "paymentDetails",
      "taxRate",
      "isBusinessCustomer",
      "discount",
      "discountApplied",
      "orderTrackingInfo",
    ]),
    shippingMethod() {
      let shippingMethod;
      if (
        this.orderTrackingInfo.shippingMethod &&
        this.orderTrackingInfo.shippingCosts
      ) {
        shippingMethod = {
          ...this.orderTrackingInfo.shippingMethod,
          pricing: this.orderTrackingInfo.shippingCosts,
          priceCents:
            this.orderTrackingInfo.shippingCosts.calculatedTaxes.price*100,
        };
      } else {
        shippingMethod = this.$store.getters
          .shippingCountryById(this.paymentDetails.shippingAddress.countryId)
          .shippingMethods.find(
            (method) =>
              method.shippingMethodId === this.paymentDetails.shippingMethodId
          );
      }
      let price = shippingMethod.priceCents;
      if (
        shippingMethod.shippingMethod === "Standard-Versand" &&
        // TODO: This constant value needs to be calculated dynamically
        (this.positionPrice.netPrice >= 250 || // this is in CHF!!
          (this.discountApplied && this.discount.rules.freeShipping))
      ) {
        price = 0;
      }
      return {
        ...shippingMethod,
        pricing: calculateTaxes(price, this.taxRate),
      };
    },
    smallOrderSurcharge() {
      if (this.orderTrackingInfo.smallOrderSurcharge) {
        return this.orderTrackingInfo.smallOrderSurcharge;
      }
      return calculateTaxes(
        this.minimumOrderValue - this.positionPrice.netPrice,
        this.taxRate
      );
    },
    cartSum() {
      if (this.orderTrackingInfo.price) {
        return calculateTaxes(
          this.orderTrackingInfo.price.positionPrice,
          this.orderTrackingInfo.price.calculatedTaxes.taxRate
        );
      }
      return null;
    },
    orderSum() {
      if (this.orderTrackingInfo && this.orderTrackingInfo.price) {
        return this.orderTrackingInfo.price;
      }
      let positionPrice = Math.max(
        this.positionPrice.netPrice,
        this.minimumOrderValue
      );
      let shippingNetPrice = this.shippingMethod.pricing.netPrice/100;
      let orderSum = calculateTaxes(positionPrice + shippingNetPrice, this.taxRate);
      if (this.discountApplied && positionPrice !== minimumOrderValue) {
        orderSum.beforeDiscount = calculateTaxes(
          this.positionPrice.beforeDiscount.netPrice + shippingNetPrice,
          this.taxRate
        );
      }
      return orderSum;
    },
  },
};
</script>

<style scoped></style>
